import React, { PropsWithChildren } from 'react';

import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import {
    Tooltip as CoreTooltip,
    TooltipText as CoreTooltipText,
} from '@instinet-analytics/core-lib';

type TooltipProps = PropsWithChildren<{
    text?: TooltipText | string;
    neverHide?: boolean;
    className?: string;
    showDelay?: number;
}>;

export type TooltipText = CoreTooltipText;

export default function Tooltip({
    text,
    children,
    neverHide,
    className,
    showDelay,
}: TooltipProps) {
    const { hideTooltips } = useSelectAppSettings();

    if (!text || (hideTooltips && !neverHide)) {
        return <>{children}</>;
    }

    return (
        <CoreTooltip text={text} className={className} showDelay={showDelay}>
            {children}
        </CoreTooltip>
    );
}
